import Grid from '@mui/material/Grid';
import TextFieldComp from '../../../components/TextField/textFieldComp';
import Box from '@mui/material/Box';
import ButtonComp from '../../../components/Button/buttonComp';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import * as Yup from 'yup';

function AddEditDairyMaster({
    closeModal = () => { },
    type = 'add',
    selectedRowObject = {},
    addUpdateDairyMasterApi,
}) {
    const validationSchema = Yup.object().shape({
        cattleType: Yup.string()
            .matches(/^[A-Za-z\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]{1,50}$/, 'Invalid dairy name')
            .required('Dairy name is required'),
        cattleSubType: Yup.string()
            .matches(/^[A-Za-z\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]{1,50}$/, 'Invalid dairy type')
            .required('Dairy type is required'),
        income: Yup.string()
            .matches(/^\d{1,10}(\.\d{1,2})?$/, 'Invalid income')
            .required('Income is required'),
    });
    const formik = useFormik({
        initialValues:
            type === 'add'
                ? {
                    id: '',
                    cattleType: '',
                    cattleSubType: '',
                    income: '',
                }
                : selectedRowObject,
        enableReinitialize: true,
        validationSchema,
        onSubmit: async values => {
            try {
                await addUpdateDairyMasterApi(values);
                closeModal();
            } catch (error) {
                console.error('API Error:', error);
            }
        },
    });
    return (
        <form onSubmit={formik.handleSubmit} noValidate>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '48px' }}>
                <Grid container spacing={'16px'}>
                    <Grid item xs={12} md={6}>
                        <TextFieldComp
                            label={'Cattle Type'}
                            name={'cattleType'}
                            required
                            value={formik.values['cattleType'] ?? ''}
                            onChange={formik.handleChange}
                            error={
                                formik.touched['cattleType'] &&
                                Boolean(formik.errors['cattleType'])
                            }
                            errorMessage={
                                formik.touched['cattleType'] && formik.errors['cattleType']
                            }
                            onBlur={formik.handleBlur}
                            maxLength={50}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextFieldComp
                            label={'Cattle Sub Type'}
                            name={'cattleSubType'}
                            required
                            value={formik.values['cattleSubType'] ?? ''}
                            onChange={formik.handleChange}
                            error={
                                formik.touched['cattleSubType'] &&
                                Boolean(formik.errors['cattleSubType'])
                            }
                            errorMessage={
                                formik.touched['cattleSubType'] && formik.errors['cattleSubType']
                            }
                            onBlur={formik.handleBlur}
                            maxLength={50}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextFieldComp
                            label={'Income'}
                            name={'income'}
                            type={'number'}
                            maxLength={10}
                            required
                            value={formik.values['income'] ?? ''}
                            onChange={(event) => {
                                if (/^\d*\.?\d{0,2}$/.test(event.target.value)) {
                                    formik.handleChange(event);
                                }
                            }}
                            error={
                                formik.touched['income'] &&
                                Boolean(formik.errors['income'])
                            }
                            errorMessage={
                                formik.touched['income'] && formik.errors['income']
                            }
                            onBlur={formik.handleBlur}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={'16px'}>
                    <Grid item xs={12} md={6}>
                        <ButtonComp
                            variant="outlined"
                            className="text-bold-16px"
                            value="Cancel"
                            height="48px"
                            width="100%"
                            padding="14px 24px"
                            textcolor="#F37021"
                            borderRadius="8px"
                            border="1px solid #F37021"
                            onClick={closeModal}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <ButtonComp
                            type="submit"
                            className="text-bold-16px"
                            value={type === 'add' ? 'Add' : 'Save'}
                            disabled={!formik.dirty || !formik.isValid}
                            gradient="linear-gradient(168deg, #F37021 -13.5%, #FDBA12 119.9%)"
                            height="48px"
                            width="100%"
                            padding="14px 24px"
                            textcolor="#fff"
                            borderRadius="8px"
                        />
                    </Grid>
                </Grid>
            </Box>
        </form>
    );
}

AddEditDairyMaster.propTypes = {
    closeModal: PropTypes.func,
    type: PropTypes.string,
    selectedRowObject: PropTypes.object,
    addUpdateDairyMasterApi: PropTypes.func.isRequired,
};

export default AddEditDairyMaster;
